import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { style: { padding: 24, fontFamily: 'sans-serif' }, children: [_jsx("h2", { children: "Something went wrong" }), _jsx("p", { children: this.state.error?.message }), _jsx("button", { onClick: () => this.setState({ hasError: false, error: null }), children: "Try again" })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
